// extracted by mini-css-extract-plugin
export default {"Field":"IconField_Field__4SF73","Label":"IconField_Label__I-gPc","IconBox":"IconField_IconBox__IhWvq","TabContent":"IconField_TabContent__grXR8"};